class Level {
    constructor(json) {
        this.name = json.name;
        this.level = Number(json.level);
        this.currentXP = Number(json.currentXP);
        this.neededXP = Number(json.neededXP);
    }
}
export default Level;